import { render, staticRenderFns } from "./DownloadMaterials.vue?vue&type=template&id=497d6c57&scoped=true&"
import script from "./DownloadMaterials.vue?vue&type=script&lang=js&"
export * from "./DownloadMaterials.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMaterials.vue?vue&type=style&index=0&id=497d6c57&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497d6c57",
  null
  
)

export default component.exports